module.exports = __webpack_public_path__ + "static/img/favicon.8843a7d9.png";